


























































import moment from 'moment'
import TextBox from '@/views/atoms/TextBox.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import PopupComfirmSave from '@/views/template/PopupComfirmSave.vue'
import ApiClient from '@/common/api'
import PopupGasMeterEdit from '@/views/template/PopupGasMeterEdit.vue'
import Global from '@/common/global.js'
import PopupComplete from '@/views/template/PopupComplete.vue'

export default
  components: {
    TextBox
    BlueButton
    PopupComfirmSave
    PopupGasMeterEdit
    PopupComplete
  }

  data: () ->
    yearList: []
    lastYearList: []
    year: moment().format('yyyy')
    lastYear: moment().subtract(1, 'years').format('yyyy')
    oneMonthAgo: moment().subtract(1, 'months').format('yyyy/MM/DD')
    id: ''
    isShowPopup: {}
    gasMeter: ''
    gas_meter_id: ''
    year: ''
    month: ''
    complete: ''

  created: () ->
    date = new Date();
    @year = date.getFullYear()
    @getGasmeter(@year);

  methods: {
    checkId: (id) ->
      @id = id
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
    save_click: () ->
      @closePopup('save')
    returnDateTime: (date) ->
      return date.replace(/^.{5}/, '')
    getGasmeter: (year) ->
      api = new ApiClient()
      data = await api.get('/user/gas_meter/list/' + year, null, null, true)
      @yearList = data.list[year]
      lastYear = year - 1
      @lastYearList = data.list[lastYear]
    checkMonth: (created) ->
        nextMonth = moment(created).add(1, 'month').add(1, 'minute').format('YYYY/MM/DD HH:mm')
        toDay = moment().format('YYYY/MM/DD HH:mm')
        return moment(toDay).isBetween(created, nextMonth, 'minute', '[)')
    backgroundColor: (created) ->
      if (created != '')
        if !@checkMonth(created)
          return 'background-color: #F2F2F2;'
      return 'cursor: pointer;'
    clickCell: (id, gasMeter, gas_meter_id, k, created) ->
      if (created != '')
        if !@checkMonth(created)
          return
      @id = id
      @gasMeter = gasMeter
      @gas_meter_id = gas_meter_id
      @month = k
      @showPopup('edit');
    save: (v) ->
      if @id
        param =
          id: @id
          value: v.value
        @complete = '変更'
      else
        param =
          gas_meter_id: @gas_meter_id
          year: @year
          month: @month
          value: v.value
        @complete = '変更'
      api = new ApiClient()
      data = await api.post('/user/gas_meter/save', param, true, true)
      if data.errors.length == 0
        @showPopup('complete')
        @getGasmeter(@year)
        @closePopup('edit')
    returnNum: (num) -> 
      return Global.comma(num)
  }

